import { useCallback, useState } from 'react';
import {
  AppDatePicker,
  AppInput,
  AppRemixIcon,
} from '@/layout/AppComponents';
import ReactDOMServer from 'react-dom/server';
import { Formik } from 'formik';
import ResourceManagerCategorySelect from '../../../../components/form/Selects/ResourceManagerCategorySelect';
import ResourceManagerResourceSelect from '../../../../components/form/Selects/ResourceManagerResourceSelect';
import Translator from '../../../../components/helpers/Translator';
import _ from 'lodash';

export default function ResourceManagerCalendarFilters({
  currentYear,
  isXls = false,
  onHandleFilters,
  onReset,
}) {
  const [initialValues] = useState({
    startDate: `01/01/${currentYear}`,
    endDate: `31/12/${currentYear}`,
    obligationHex: '',
    resources: [],
    categories: [],
  });

  const isDirty = useCallback(
    (values) =>
      !_.isEqual(
        _.omit(initialValues, ['startDate', 'endDate']),
        _.omit(values, ['startDate', 'endDate'])
      ),
    [initialValues]
  );

  const handleResetForm = useCallback((resetForm) => {
    resetForm({
      values: initialValues,
    });
    onReset();
  }, initialValues);

  return (
    <Formik initialValues={initialValues} onSubmit={onHandleFilters}>
      {({ setFieldValue, handleSubmit, values, resetForm }) => (
        <form onSubmit={handleSubmit}>
          <div className="row">
            {isXls && (
              <>
                <div className="col-lg-6">
                  <AppDatePicker
                    title={
                      <Translator
                        file="module-resourceManager"
                        name="resource.start.date"
                      />
                    }
                    value={values?.startDate}
                    placeholder="DD/MM/YYYY"
                    onChange={(opt) => setFieldValue('startDate', opt)}
                    popperClassName="react-datepicker-popper react-datepicker-popper-1000"
                    isClearable
                    showYearDropdown
                    showMonthDropdown
                    hasToggleType
                  />
                </div>
                <div className="col-lg-6">
                  <AppDatePicker
                    title={
                      <Translator
                        file="module-resourceManager"
                        name="resource.end.date"
                      />
                    }
                    value={values?.endDate}
                    placeholder="DD/MM/YYYY"
                    onChange={(opt) => setFieldValue('endDate', opt)}
                    popperClassName="react-datepicker-popper react-datepicker-popper-1000"
                    isClearable
                    showYearDropdown
                    showMonthDropdown
                    hasToggleType
                  />
                </div>
              </>
            )}
            <div className="col-lg-6">
              <AppInput
                title={ReactDOMServer.renderToString(
                  <Translator
                    file="module-resourceManager"
                    name="resource.obligations-code-input"
                  />
                )}
                placeholder={
                  <Translator
                    file="module-legalCompliance"
                    name="split.by.commas"
                  />
                }
                icon={<AppRemixIcon icon="barcode" />}
                value={values.obligationHex}
                onChange={(v) => setFieldValue('obligationHex', v)}
                isClearable
              />
            </div>
            <div className="col-lg-6">
              <ResourceManagerCategorySelect
                value={values.categories}
                onHandleChange={(v) => setFieldValue('categories', v)}
                hasSearchBox
                hasSelectOptions
              />
            </div>
            <div className="col-lg-6">
              <ResourceManagerResourceSelect
                value={values.resources}
                onHandleChange={(v) => setFieldValue('resources', v)}
                hasSearchBox
                hasSelectOptions
              />
            </div>
            <div className="col-lg-12">
              <div className="mt-3 float-right">
                {isDirty(values) && (
                  <button
                    type="buton"
                    className="btn btn-xs btn-danger mr-2"
                    onClick={() => handleResetForm(resetForm)}
                  >
                    <Translator
                      file="module-legalCompliance"
                      name="delete.filters"
                    />
                  </button>
                )}
                <button type="submit" className="btn btn-xs btn-outline-light">
                  <Translator file="filter" name="filter.apply" />
                </button>
              </div>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
}
